var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg12PxStar = function Svg12PxStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.95 4.323a1.01 1.01 0 0 0-.818-.69l-2.918-.424L6.91.568C6.566-.131 5.433-.13 5.09.567L3.786 3.21l-2.917.424c-.385.055-.699.32-.819.69s-.021.769.257 1.04l2.111 2.058-.499 2.905a1.01 1.01 0 0 0 .402.991c.313.229.725.26 1.069.079l2.609-1.372 2.61 1.372a1.01 1.01 0 0 0 1.069-.079c.313-.229.468-.608.402-.991l-.499-2.905 2.11-2.058c.279-.271.378-.67.258-1.04Z"
  })));
};
export default Svg12PxStar;